function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "47",
  height: "47",
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M23.5 47a23.5 23.5 0 100-47 23.5 23.5 0 000 47z",
  fill: "#4D76A1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.61 33.8h1.85s.55-.05.84-.36c.26-.28.25-.81.25-.81s-.03-2.47 1.11-2.84c1.14-.36 2.6 2.4 4.13 3.45 1.17.8 2.05.63 2.05.63l4.12-.06s2.16-.13 1.14-1.83c-.09-.14-.6-1.25-3.07-3.55-2.58-2.4-2.23-2 .88-6.15 1.9-2.53 2.65-4.07 2.41-4.73-.22-.63-1.62-.47-1.62-.47l-4.64.03s-.34-.04-.6.1c-.24.16-.4.5-.4.5s-.74 1.96-1.72 3.62c-2.06 3.51-2.89 3.7-3.23 3.48-.78-.5-.59-2.04-.59-3.13 0-3.4.52-4.82-1-5.18-.5-.12-.88-.2-2.17-.22-1.65-.02-3.05 0-3.85.4-.52.25-.93.83-.68.86.3.04 1 .2 1.37.7.47.64.45 2.1.45 2.1s.28 4-.63 4.5c-.63.33-1.49-.36-3.33-3.55-.94-1.63-1.65-3.43-1.65-3.43s-.14-.34-.39-.52c-.3-.21-.71-.28-.71-.28l-4.4.02s-.67.02-.91.31c-.22.26-.02.79-.02.79s3.45 8.07 7.36 12.14c3.58 3.73 7.65 3.49 7.65 3.49z",
  fill: "#fff"
})));